export default "__VITE_ASSET__B9cgx2xt__"